export const civilityList = [
    'Mr',
    'Mrs',
    'Miss'
]